const parseFluidNumber = (value) => {
  if (value === null || value === undefined || value === '') return null
  const parsed = Number(value)
  return Number.isNaN(parsed) ? null : parsed
}

export const getFluidTotal = (jsonData, totalKey, fallbackKeys) => {
  let total = parseFluidNumber(jsonData?.[totalKey])

  if (total === null) {
    const values = fallbackKeys
      .map((key) => parseFluidNumber(jsonData?.[key]))
      .filter((value) => value !== null)

    if (values.length) {
      total = values.reduce((sum, value) => sum + value, 0)
    }
  }

  // The stored intakeTotal excludes medication volume. Add it once when
  // displaying the chart; never overwrite the original record's total.
  if (totalKey === 'intakeTotal') {
    const medications = parseFluidNumber(jsonData?.intakeMedications)
    if (medications !== null) total = (total ?? 0) + medications
  }

  return total ?? ''
}
